import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-12 mt-3"
}
const _hoisted_4 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modal: "",
    header: _ctx.header != null && _ctx.header != ''  ? _ctx.header : 'Confirmation',
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isVisible) = $event)),
    style: {width: '40vw'},
    onHide: _ctx.cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          class: "p-button-text p-button-sm",
          label: "No",
          icon: "pi pi-times",
          onClick: _ctx.cancel
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "p-button-sm",
          label: "Yes",
          icon: "pi pi-check",
          onClick: _ctx.confirm,
          disabled: _ctx.v$.returnObj.remarks.$invalid
        }, null, 8, ["onClick", "disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("i", {
              class: _normalizeClass(["mr-3 align-self-center", _ctx.icon != null && _ctx.icon != '' ? _ctx.icon : 'pi pi-exclamation-triangle']),
              style: {"font-size":"1.5rem"}
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(_ctx.message), 1)
          ]),
          (_ctx.withRemarks)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Textarea, {
                  modelValue: _ctx.returnObj.remarks,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.returnObj.remarks) = $event)),
                  autoResize: true,
                  rows: "5",
                  cols: "30",
                  maxlength: "255",
                  placeholder: "Remarks",
                  autofocus: ""
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["header", "visible", "onHide"]))
}